export type Testimonial = {
  quote: string;
  name: string;
  location: string;
  flag: string;
  img: string;
};

export const testimonials: Testimonial[] = [
  {
    quote:
      'Güç kullanımı raporlarımın İçişleri denetimine girmesinden endişe ediyordum. Her şey hukuki bir tuzak gibi görünüyordu. SIGMA SMART™ komutlarını üç gün kullandıktan sonra ilk kapsamlı raporumu yapılandırabildim. Artık vardiyamı her gün zamanında bitiriyorum.',
    name: 'Memur Mert T.',
    location: 'İstanbul · Türkiye',
    flag: '🇹🇷',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/ecd0c5e0-4049-4307-aed7-1eead41f2284.jpg',
  },
  {
    quote:
      'Dosyalar arasında kaybolmuştum ve evrak işlerinin beni sahadaki görevlerimden uzaklaştırmasından bıkmıştım. Bu sistem gerçekten işe yarıyor. Olay yeri ve delil belgelerine yönelik yapılandırılmış yaklaşım son derece kullanışlı. Raporlarım artık birimimde örnek gösterilecek düzeye ulaştı.',
    name: 'Dedektif Selin A.',
    location: 'Ankara · Türkiye',
    flag: '🇹🇷',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/ed78b3f2-0f6d-40c4-b2b0-46ee33611e74.jpg',
  },
  {
    quote:
      'Yapay zekânın mahkemede kullanılabilecek bir ifadeyi robotik göstereceğinden endişeleniyordum. SIGMA SMART™ bu konudaki düşüncemi değiştirdi. Komutlar profesyonel bir yapı sunuyor. İlk günden itibaren kendimi daha hazırlıklı hissettim.',
    name: 'Başkomiser Deniz P.',
    location: 'İzmir · Türkiye',
    flag: '🇹🇷',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/ffa823e2-399c-4f99-8812-cbc55e9843bd.jpg',
  },
];
